import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForTv } from 'utils/index';

import { KeyboardAppearanceType } from './SimpleKeyboard';
import { HORIZONTAL_NUMERIC_KEYBOARD, KeyItemProps } from './helpers/keyboardItems';

type HorizontalNumericKeyboardProps = {
  onHandleKeyPress: (keyItem: KeyItemProps) => void;
  appearance?: KeyboardAppearanceType;
};

const KEYBOARD_LENGHT = HORIZONTAL_NUMERIC_KEYBOARD.length;
const ITEM_SIZE = 52;
const GAP = 8;
const TOTAL_COLUMNS = 10;
const TOTAL_ROWS = Math.ceil(KEYBOARD_LENGHT / TOTAL_COLUMNS);

const HorizontalNumericKeyboard: React.FC<HorizontalNumericKeyboardProps> = ({
  onHandleKeyPress,
  appearance = 'default',
}) => {
  const backgroundColor =
    appearance === 'strong' ? 'rgba(6, 113, 224, 0.15)' : 'rgba(6, 113, 224, 0.07)';

  const getItemWidth = (columns?: number) => {
    const col = columns ?? 1;

    return calcSizeForTv(ITEM_SIZE * col + GAP * (col - 1));
  };

  return (
    <View style={styles.container}>
      {HORIZONTAL_NUMERIC_KEYBOARD.map((keyItem, index) => (
        <View
          key={`${keyItem.item}-${index}`}
          style={{
            width: getItemWidth(keyItem.columns),
            marginRight: calcSizeForTv(GAP),
            marginBottom: calcSizeForTv(GAP),
          }}>
          <Pressable
            role="button"
            style={{
              ...styles.keyButton,
              backgroundColor,
              height: calcSizeForTv(ITEM_SIZE),
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => onHandleKeyPress(keyItem)}>
            <Text style={styles.keyText}>{keyItem.symbol}</Text>
          </Pressable>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: calcSizeForTv(ITEM_SIZE * TOTAL_COLUMNS + GAP * TOTAL_COLUMNS),
    height: calcSizeForTv(TOTAL_ROWS * ITEM_SIZE + (TOTAL_ROWS - 1) * GAP),
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  keyButton: {
    paddingHorizontal: 0,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 2,
  },
  keyText: {
    fontSize: calcSizeForTv(20),
    color: '#FFF',
  },
});

export default HorizontalNumericKeyboard;
